import { FEATURE_ENUM } from '@partoohub/api-client';

import { useHasFeature } from 'app/common/hooks/accessesAndPermissions/pages/useHasFeature';

export const useHasFeedbackManagementPage = (): boolean => {
    return useHasFeature(FEATURE_ENUM.FEEDBACK_MANAGEMENT);
};
